/* Rolling month/year helpers shared by Projects and Invoices pages */

export const WEEK_PERIOD_LAST7 = 'last7';
export const WEEK_PERIOD_PREV7 = 'prev7';

function formatDateLocal(d) {
	const year = d.getFullYear();
	const month = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

export function isWeekPeriodToken(value) {
	return value === WEEK_PERIOD_LAST7 || value === WEEK_PERIOD_PREV7;
}

/** Last 7 days: today and the six prior calendar days. Previous 7 days: the seven days before that. */
export function getWeekPeriodDateRange(token) {
	const now = new Date();
	const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	if (token === WEEK_PERIOD_LAST7) {
		const start = new Date(today);
		start.setDate(start.getDate() - 6);
		return { startDate: formatDateLocal(start), endDate: formatDateLocal(today) };
	}
	if (token === WEEK_PERIOD_PREV7) {
		const end = new Date(today);
		end.setDate(end.getDate() - 7);
		const start = new Date(end);
		start.setDate(start.getDate() - 6);
		return { startDate: formatDateLocal(start), endDate: formatDateLocal(end) };
	}
	return null;
}

/** Query params for projects list (week tokens use startDate/endDate; invoices use resolveMonthYearParams). */
export function resolveProjectPeriodParams(month, year) {
	if (isWeekPeriodToken(month)) {
		const range = getWeekPeriodDateRange(month);
		return {
			month: '',
			year: '',
			startDate: range.startDate,
			endDate: range.endDate,
		};
	}

	let yearParam = year;
	let monthParam = month;
	if (month && month.includes('-')) {
		const { year: y, month: m } = parsePeriodValue(month);
		yearParam = y;
		monthParam = m;
	}
	return { month: monthParam, year: yearParam, startDate: '', endDate: '' };
}

export function generateRolling12Months(locale = 'en') {
	const months = [];
	const now = new Date();
	const localeTag = locale === 'et' ? 'et-EE' : 'en-US';

	for (let i = 0; i < 12; i++) {
		const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
		const year = date.getFullYear();
		const month = date.getMonth() + 1;
		const monthName = date.toLocaleString(localeTag, { month: 'long' });

		months.push({
			label: `${monthName} ${year}`,
			value: `${year}-${month}`,
		});
	}

	return months;
}

export function parsePeriodValue(periodValue) {
	if (periodValue && periodValue.includes('-')) {
		const [y, m] = periodValue.split('-');
		return { year: y, month: m };
	}
	return { year: '', month: '' };
}

export function resolveMonthYearParams(month, year) {
	let yearParam = year;
	let monthParam = month;
	if (month && month.includes('-')) {
		const { year: y, month: m } = parsePeriodValue(month);
		yearParam = y;
		monthParam = m;
	}
	return { year: yearParam, month: monthParam };
}
